import { createFileRoute } from "@tanstack/react-router";
import { fallback, zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { DocumentTitle } from "@/components";
import { EditProductPage } from "@/modules/product";
import { requireAuthAndPermission } from "@/utils";

const editProductSearchSchema = z.object({
  draft: fallback(z.boolean(), false).default(false)
});

export const Route = createFileRoute("/products/list/$slug/edit")({
  validateSearch: zodValidator(editProductSearchSchema),
  beforeLoad: requireAuthAndPermission,
  component: () => (
    <>
      <DocumentTitle
        title="Edit Product"
        description="Edit your product details on the LAMPU Marketplace."
      />
      <EditProductPage />
    </>
  )
});
